export default __webpack_public_path__ + "media/images/brands/expmessenger/backgrounds/bg-02-9eaf4b02fd9bfdde221c3d7fe646096a.jpg";